export type CopyStatus = {
  id: string;
  display_date: Date;
  permission_id: string;
};

export type ICopyStatuses = CopyStatus[];

export class CopyStatuses {
  private data: CopyStatus[];

  constructor(data: ICopyStatuses) {
    this.data = data.map((item) => ({
      id: item.id,
      display_date: new Date(item.display_date),
      permission_id: item.permission_id,
    }));
};

  getStatuses(): CopyStatus[] {
    return this.data;
  }
}
